package org.example.project.service

import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager

@Serializable
data class MobileAnsicht(
    val screenKey: String = "",
    val mode: String = "MOBILE"
)

object MobileAnsichtenApi {
    private val json = Json { ignoreUnknownKeys = true }

    suspend fun all(): List<MobileAnsicht> {
        val raw = runCatching { LumaticaApiManager.call("mobileansichten/all") }.getOrDefault("")
        if (raw.isBlank() || raw == "null") return emptyList()
        return runCatching { json.decodeFromString<List<MobileAnsicht>>(raw) }.getOrDefault(emptyList())
    }

    suspend fun available(): List<MobileAnsicht> {
        val fallback = listOf(MobileAnsicht(screenKey = "Zeiterfassung", mode = "AUS"))
        val raw = runCatching { LumaticaApiManager.call("mobileansichten/available") }.getOrDefault("")
        return runCatching { json.decodeFromString<List<MobileAnsicht>>(raw) }.getOrDefault(fallback)
    }

    suspend fun save(config: List<MobileAnsicht>): List<MobileAnsicht> {
        val raw = LumaticaApiManager.postJson("mobileansichten/save", json.encodeToString(config))
        return runCatching { json.decodeFromString<List<MobileAnsicht>>(raw) }.getOrDefault(config)
    }

    fun active(config: List<MobileAnsicht>, screenKey: String, companion: Boolean): Boolean {
        val mode = config.firstOrNull { it.screenKey == screenKey }?.mode?.uppercase() ?: "MOBILE"
        return if (companion) mode == "COMPANION" || mode == "BEIDE" else mode == "MOBILE" || mode == "BEIDE"
    }
}
